module.exports = __webpack_public_path__ + "static/media/Image_UC3_Wokout_Results_331_227@2X.2661729a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/Image_UC3_Wokout_Results_331_227@2X.png
// module id = 1272
// module chunks = 0